const Header = (props) => {

    const { resortName = '' } = props;

    return (
        <div className="rs-banner-top">
            <h2>ROOMS &amp; SUITES</h2>
        </div>
    );
};

export default Header;
